import Vue from 'vue'

/**
 * 千位符
 */
Vue.filter("formatMoney", (value) => {
  if (!value) {
    return '0'
  }
  const intPartFormat = value?.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
  return intPartFormat
})